<template>
  <div class="internal">
    <div class="container">
      <h1>Contact Us</h1>
      <hr />
      <p class="mb-2 mb-lg-4">
        To receive a competitive quotation from an established company like SEA Scaffolding then please do not hesitate to forward any information over to
        <a
          href="mailto:info@seascaffolding.com"
        >info@seascaffolding.com</a> or call
        <a href="tel:01502711750">01502 711750</a> for a free quotation.
      </p>

      <div class="row contact-us">
        <div class="col-lg-5">
          <div class="address">
            <p>
              <strong>SEA Scaffolding limited</strong>
              <br />Unit 5b Site 2
              <br />Sandpit Lane
              <br />Worlingham
              <br />Beccles
              <br />Suffolk
              <br />NR347TH
            </p>
          </div>
          <div>
            <p>
              <a href="tel:01502711750">01502 711750</a>
            </p>
            <p>
              <a href="mailto:info@seascaffolding.com">info@seascaffolding.com</a>
            </p>
          </div>
        </div>
        <div class="col-lg-7">
          <div v-if="errors.length" class="errors">
            <strong>
              <p>Please correct the following error(s):</p>
            </strong>
            <ul>
              <li v-for="error in errors" :key="error">{{ error }}</li>
            </ul>
          </div>
          <div v-if="success" class="success">
            <b>Your message has been sent successfully</b>
          </div>
          <netlify-form name="contact-form" netlify-honeypot="bot-field">
            <div class="row">
              <div class="form-group col-md-6">
                <label class="required" for="first-name">First name</label>
                <input
                  v-model="firstName"
                  name="firstName"
                  id="first-name"
                  class="form-control"
                  type="text"
                  placeholder="Your first name"
                  required
                />
              </div>
              <div class="form-group col-md-6">
                <label class="required" for="last-name">Last name</label>
                <input
                  v-model="lastName"
                  name="lastName"
                  id="last-name"
                  class="form-control"
                  type="text"
                  placeholder="Your last name"
                  required
                />
              </div>
              <div class="form-group col-md-6">
                <label class="required" for="email-name">Email</label>
                <input
                  v-model="email"
                  name="email"
                  id="email-name"
                  class="form-control"
                  type="text"
                  placeholder="Your email"
                  required
                />
              </div>
              <div class="form-group col-md-6">
                <label class="required" for="phone">Phone</label>
                <input
                  v-model="phone"
                  name="phone"
                  id="phone"
                  class="form-control"
                  type="text"
                  placeholder="Your phone"
                  required
                />
              </div>
              <div class="form-group col-md-12">
                <label class="required" for="message">Your message</label>
                <textarea
                  v-model="message"
                  name="message"
                  id="message"
                  class="form-control"
                  placeholder="Your message"
                  required
                ></textarea>
              </div>
              <div class="col">
                <label class="required">GDPR Agreement</label>
                <div class="custom-control custom-checkbox">
                  <input
                    v-model="gdpr"
                    class="custom-control-input"
                    type="checkbox"
                    name="checkbox"
                    id="checkbox"
                    required
                  />
                  <label for="checkbox" class="custom-control-label">
                    I consent to having this website store my submitted
                    information so they can respond to my enquiry.
                  </label>
                </div>
              </div>
              <div class="form-group col-md-12">
                <button @click="onSubmit" type="submit" class="form-button">Submit</button>
              </div>
            </div>
          </netlify-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NetlifyForm from "@/components/forms/NetlifyForm";

export default {
  name: "contact-us",
  components: {
    NetlifyForm,
  },

  data() {
    return {
      firstName: null,
      lastName: null,
      phone: null,
      email: null,
      message: null,
      gdpr: false,
      errors: [],
      success: false,
    };
  },

  methods: {
    onSubmit(e) {
      this.errors = [];
      this.success = false;

      if (!this.firstName) {
        this.errors.push("First Name required");
      }
      if (!this.lastName) {
        this.errors.push("Last Name required");
      }
      if (!this.email) {
        this.errors.push("Email required");
      } else if (!this.validEmail(this.email)) {
        this.errors.push("Valid email required");
      }
      if (!this.phone || !this.validPhoneNumber(this.phone)) {
        this.errors.push("Valid phone number required");
      }
      if (!this.message) {
        this.errors.push("Message required");
      }
      if (!this.gdpr) {
        this.errors.push(
          "We are unable to submit your enquiry, without consent to hold your data"
        );
      }
      if (this.errors.length) {
        e.preventDefault();
      }
    },
    validEmail: function (email) {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validPhoneNumber: function (phoneNumber) {
      phoneNumber = phoneNumber.replace(/[()]+/g, "");
      let number = /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?#(\d{4}|\d{3}))?$/;
      return number.test(phoneNumber);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/ContactUs.vue